import React, { memo, ReactElement, ReactNode, useCallback } from "react";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { PAYMENT_FALLBACK_ALERT_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "./PayButton.v4.scss";

interface PayButtonProps {
    children: ReactNode;
    onClick: VoidFunction;
}

const PayButton = (props: PayButtonProps): ReactElement => {
    const onClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            props.onClick();
        },
        [props.onClick],
    );

    return (
        <div data-testid={PAYMENT_FALLBACK_ALERT_TEST_IDS.PRIMARY_ACTION_BUTTON} className={styles.payButtonContainer}>
            <SuperButton
                className={styles.payButton}
                onClick={onClick}
                buttonType="primary"
                variant="fullwidth"
                buttonSize="medium"
            >
                {props.children}
            </SuperButton>
        </div>
    );
};

export default memo(PayButton);
